import { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { useMenuContext } from 'state/menu';
import { UserSelectionModifierSlotMap } from 'state/product-wizard-v2/types';

import { getProductPropsSelections } from './utils';

export const useProductPropsSelections = () => {
  const { priceForItemOptionModifier } = useMenuContext();

  const { formatMessage } = useIntl();

  const buildProductPropsSelections = useCallback(
    (modifierSelections: UserSelectionModifierSlotMap) =>
      getProductPropsSelections({
        formatMessage,
        modifierSelections,
        priceForItemOptionModifier,
      }),
    [formatMessage, priceForItemOptionModifier]
  );

  return {
    buildProductPropsSelections,
  };
};
